// pared down from
// https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/debounceCore.js
export default <F extends (this: any, ...args: any[]) => any>(
  fn: F,
  wait: number,
  context?: unknown
) => {
  let timeout: number;

  function debouncer(...args: Parameters<F>) {
    debouncer.reset();

    const callback = function () {
      fn.apply(context, args);
    };
    timeout = setTimeout(callback, wait);
  }

  debouncer.reset = function () {
    clearTimeout(timeout);
  };

  return debouncer;
};
